import { useCallback } from 'react';
import { PackType } from 'types/enums';
import { PACK, PAGINATED_PACK_SAMPLES_QUERY } from 'apollo/pack/pack.gql';
import {
    REPACK,
    PAGINATED_REPACK_SAMPLES_QUERY,
} from 'apollo/repack/repack.gql';
import { useLazyQuery } from '@apollo/client';

const useOptimisticQuery = () => {
    const [getPack] = useLazyQuery(PACK);
    const [getPackSamples] = useLazyQuery(PAGINATED_PACK_SAMPLES_QUERY);

    const [getRepack] = useLazyQuery(REPACK);
    const [getRepackSamples] = useLazyQuery(PAGINATED_REPACK_SAMPLES_QUERY);

    const optimisticPreviewQuery = useCallback(
        ({
            guid,
            type,
            signal,
        }: {
            guid: string;
            type: PackType;
            signal: AbortSignal;
        }) => {
            switch (type) {
                case PackType.Pack:
                    getPack({
                        variables: { packSlugOrGuid: guid },
                        context: {
                            fetchOptions: {
                                signal: signal,
                            },
                        },
                    });
                    getPackSamples({
                        variables: { packGuid: guid, take: 8 },
                        context: {
                            fetchOptions: {
                                signal: signal,
                            },
                        },
                    });
                    break;

                case PackType.RePack:
                    getRepack({
                        variables: { repackSlugOrGuid: guid },
                        context: {
                            fetchOptions: {
                                signal: signal,
                            },
                        },
                    });
                    getRepackSamples({
                        variables: { repackGuid: guid, take: 8 },
                        context: {
                            fetchOptions: {
                                signal: signal,
                            },
                        },
                    });
                    break;
            }
        },
        [getPack, getPackSamples, getRepack, getRepackSamples],
    );

    return optimisticPreviewQuery;
};

export default useOptimisticQuery;
